module.exports = __webpack_public_path__ + "8772028edbe2979fbbe6929599f3e1cb.png";